( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-logo-carousel').each(function () {
			const carousel = $(this);
			const sliderEl = $('.swiper', carousel)[0];
			const sliderFull = $(sliderEl).hasClass('swiper--full');
			const navParent = $('.js-carousel-nav', carousel).parent();

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				spaceBetween: 0,
				slidesPerView: 'auto',
				loop: true,
				grabCursor: true,
				// speed: 3000,
				// autoplay: {
				// 	delay: 0,
				// },

				navigation: {
					nextEl: $('.js-carousel-nav-next', carousel)[0],
					prevEl: $('.js-carousel-nav-prev', carousel)[0],
				},

				on: {
					beforeInit: function () {
						let numSlides = $('.js-carousel-slide', carousel).length;
						if ( numSlides > 9 ) {
							this.params.loop = false;
						}
					}
				}
			});
		});
	} );
} )( jQuery, document, window );
